import { LabelMode } from "./../../../../utils/label-mode.enum";
import { CommonModule } from "@angular/common";
import { Component, inject, OnInit, signal } from "@angular/core";
import { SharedModule } from "src/shared/shared.module";
import { AuthRoutingModule } from "../../auth/auth-routing.module";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { environment } from "src/environments/environment";
import { AuthService } from "../../auth";
import { MonitorService } from "src/app/services/api/monitor.service";
import { forkJoin, Observable } from "rxjs";
import { UnderParenting } from "src/app/services/model/under-parenting.model";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-monitor",
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
  ],
  templateUrl: "./monitor.component.html",
  styleUrl: "./monitor.component.scss",
})
export class MonitorComponent implements OnInit {
  #fb = inject(FormBuilder);
  #authService = inject(AuthService);
  #monitorService = inject(MonitorService);
  #router = inject(Router);
  #route = inject(ActivatedRoute);

  currentUser = this.#authService.currentUser()!.user;
  fileUrl = environment.apiFileUrl;

  // underParenting = signal<UnderParenting[]>([]);
  form: FormGroup;
  LabelMode = LabelMode;

  isLoading = signal(false);
  isStudent = signal<boolean>(this.currentUser.role.id === 2);
  underParenting = signal<UnderParenting[]>([]);
  tabIndex = !this.#router.url.includes("quiz-record") ? 1 : 2;

  ngOnInit(): void {
    this.buildForm();
    if (!this.isStudent()) {
      this.fetchData();
    }
  }

  /**
   * Which child a parent is looking at.
   *
   * The skills report needs this in the URL: the API refuses to guess whose
   * report a parent means, because a parent of two who omits it would be shown
   * the wrong child's — and would have no way to tell.
   */
  selectedStudentId = signal<number | null>(null);

  buildForm() {
    this.form = this.#fb.group({
      student_id: [null],
    });
    this.form
      .get("student_id")
      ?.valueChanges.pipe()
      .subscribe((val) => {
        this.selectedStudentId.set(val ?? null);
        if (val) {
          const student = this.underParenting().find(
            (i) => i.student_id === val
          )?.student;

          this.#monitorService.monitorStudent.update(() => student!);

          // Put the child in the URL as well as in the form. The skills tab
          // reads whose report to show from the query string — the API refuses
          // to guess — and only the tab LINK was carrying it. A parent who
          // arrived at /profile/monitor/skills any other way (the menu, a
          // bookmark, a reload) got "ทำแบบฝึกหัดสักชุดก่อน" for a child who had
          // done plenty.
          if (!this.isStudent()) {
            this.#router.navigate([], {
              relativeTo: this.#route,
              queryParams: { student_id: val },
              queryParamsHandling: "merge",
              replaceUrl: true,
            });
          }
        }
      });
  }
  _setLoading(value: boolean, time: number = 500) {
    setTimeout(() => {
      this.isLoading.update((_) => value);
    }, time);
  }

  async fetchData() {
    this._setLoading(true, 0)
    const params = this.form.getRawValue();
    // this.isLoading.update(() => true);

    let serviceArray = [
      this.#monitorService.getUnderParenting() as Observable<any>,
    ];
    forkJoin(serviceArray).subscribe({
      next: ([under_parenting]) => {
        this.underParenting.update(() => under_parenting);
      },
      error: (error) => { },
      complete: () => {
        // `underParenting` is a signal, so `.length` was reading the arity of
        // the signal FUNCTION — always 0, so this never ran and a parent landed
        // on "ทำแบบฝึกหัดสักชุดก่อน" with no child selected, whatever their
        // children had actually done.
        if (this.underParenting().length) {
          this.form.patchValue({
            student_id: this.underParenting()[0].student_id,
          });
        }
        this._setLoading(false);
      },
    });
  }
}
